export default {
	init() {

		function ListFaqAction( container ) {

			var children;
			var childrenHeight;
			var childrenStyle;
			function getChildrenHeight( parent, add = 0, substract = 0 ) {
				childrenHeight = 0;

				children = Array.from(parent.children);

				children.forEach( function( c, i ){

					childrenStyle = getComputedStyle(c);

					childrenHeight += c.offsetHeight;
					
					childrenHeight += parseInt(childrenStyle.marginTop.replace('px','')) + parseInt(childrenStyle.marginBottom.replace('px',''));

				});

				childrenHeight += add;
				childrenHeight -= substract;

				parent.style.height = childrenHeight+'px';

			}

			// -- Category -- //

				var category;
				var categoryButtonContainer;
				var categoryButton = container.querySelectorAll('.category__button');
				var categoryQuestionContainer;
				var categoryQuestions;

				categoryButton.forEach( function( button, index ) {

					button.addEventListener('click',function() {

						category = button.closest('.listFaq__category');
						categoryQuestionContainer = category.querySelector('.category__single');
						categoryQuestions = categoryQuestionContainer.querySelectorAll('.single__question');

						if( category.classList.contains('active') ) {

							categoryQuestionContainer.style.height = '0px';
							category.classList.remove('active');

						} else {

							getChildrenHeight(categoryQuestionContainer);
							category.classList.add('active');

						}

					});

				});

			// -- END -- //


			// -- Question -- //

				var questionButton = container.querySelectorAll('.question__button');
				var questionContainer;
				var questionAnswer;

				questionButton.forEach( function( question, index ){

					question.addEventListener('click',function(){

						questionContainer = question.closest('.single__question');
						questionAnswer = questionContainer.querySelector('.question__answer');

						if( questionContainer.classList.contains('active') ) {

							getChildrenHeight(question.closest('.category__single'), 0, parseInt( questionAnswer.style.height.replace('px','') ) );
							questionContainer.classList.remove('active');
							questionAnswer.style.height = '0px';


						} else {

							questionContainer.classList.add('active');
							getChildrenHeight(questionAnswer);
							getChildrenHeight(question.closest('.category__single'), parseInt( questionAnswer.style.height.replace('px','') ), 0 );

						
						}

					});

				});

			// -- END -- //

		}


		var container = document.querySelectorAll('.listFaq');

		if( container.length == 1 ) {

			ListFaqAction( container[0] );

		}

	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
